import { render, staticRenderFns } from "./Captcha.vue?vue&type=template&id=6de1e8b4&scoped=true"
import script from "./Captcha.vue?vue&type=script&lang=js"
export * from "./Captcha.vue?vue&type=script&lang=js"
import style0 from "./Captcha.vue?vue&type=style&index=0&id=6de1e8b4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de1e8b4",
  null
  
)

export default component.exports